<template>
    <div class="about-initiative-form4">
        <slot name="how-register-modal"></slot>

        <div class="edit-info" v-if="getEditionMode">
            <b-button
                :variant="getIsDarkTheme ? 'outline-light' : 'outline-dark'"
                size="sm"
                @click="changeStatusDisabled(false)"
            >
                Editar informações
            </b-button>
        </div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <b-form-group>
                <label for="isInnovative" class="required h6">
                    Iniciativa Inovadora
                </label>
                <div>
                    (Entendemos Inovação como ideias que ainda não foram testadas e/ou implementadas e que, na sua
                    opinião, podem trazer benefícios para a proposta. Não precisa ser algo tecnológico! Inovação, muitas
                    vezes, são ideias simples e de baixo custo, mas que poucas pessoas pensaram a respeito. Inovação
                    também depende do contexto; neste caso, falamos de algo inovador para a região em que sua proposta
                    ocorrerá! Inovação é pensar diferente, testar novas maneiras de fazer as coisas!)
                </div>
                <b-form-radio-group
                    id="isInnovative"
                    name="isInnovative"
                    v-model="$v.form.isInnovative.selected.$model"
                    :options="form.isInnovative.options"
                    :state="validateState('isInnovative')"
                    stacked
                    :disabled="getIsDisabled"
                    @change="onChangeIsInnovative()"
                    v-if="
                        !isPlatform ||
                            (isPlatform &&
                                getAuthorizationData &&
                                getAuthorizationData['considera_atuacao_iniciativa'].value)
                    "
                ></b-form-radio-group>

                <NoAuthorizationMsgPP
                    v-if="
                        isPlatform &&
                            getAuthorizationData &&
                            !getAuthorizationData['considera_atuacao_iniciativa'].value
                    "
                />

                <b-form-invalid-feedback :state="validateState('isInnovative')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <div v-if="form.isInnovative.selected !== null">
                <b-form-group
                    label="Explique o porquê."
                    label-for="isInnovativeMotive"
                    v-if="form.isInnovative.selected"
                >
                    <b-form-textarea
                        id="isInnovativeMotive"
                        name="isInnovativeMotive"
                        v-model="form.isInnovativeMotive"
                        placeholder="Descreva aqui."
                        rows="6"
                        :disabled="getIsDisabled"
                        v-if="
                            !isPlatform ||
                                (isPlatform && getAuthorizationData && getAuthorizationData['explique'].value)
                        "
                    ></b-form-textarea>

                    <NoAuthorizationMsgPP
                        v-if="isPlatform && getAuthorizationData && !getAuthorizationData['explique'].value"
                    />
                </b-form-group>

                <b-form-group
                    label="Qual é o atual estágio de maturidade da sua iniciativa?"
                    label-for="maturityStage"
                    v-if="getProfileId !== 3"
                >
                    <b-form-select
                        id="maturityStage"
                        name="maturityStage"
                        v-model="form.maturityStage.selected"
                        :options="form.maturityStage.options"
                        :disabled="getIsDisabled"
                        v-if="
                            !isPlatform ||
                                (isPlatform && getAuthorizationData && getAuthorizationData['id_maturidade'].value)
                        "
                    ></b-form-select>

                    <NoAuthorizationMsgPP
                        v-if="isPlatform && getAuthorizationData && !getAuthorizationData['id_maturidade'].value"
                    />
                </b-form-group>

                <b-form-group
                    label="Em qual categoria de financiador(e) você ou sua organização se encaixa?"
                    label-for="financierCategory"
                    class="required"
                    v-if="getProfileId === 1"
                >
                    <b-form-select
                        id="financierCategory"
                        name="financierCategory"
                        v-model="$v.form.financierCategory.selected.$model"
                        :options="form.financierCategory.options"
                        :state="validateState('financierCategory')"
                        :disabled="getIsDisabled"
                        v-if="
                            !isPlatform ||
                                (isPlatform &&
                                    getAuthorizationData &&
                                    getAuthorizationData['id_categoria_financiadora'].value)
                        "
                    ></b-form-select>

                    <NoAuthorizationMsgPP
                        v-if="
                            isPlatform &&
                                getAuthorizationData &&
                                !getAuthorizationData['id_categoria_financiadora'].value
                        "
                    />

                    <b-form-invalid-feedback :state="validateState('financierCategory')">
                        Campo obrigatório
                    </b-form-invalid-feedback>
                </b-form-group>

                <div v-if="!form.isInnovative.selected">
                    <div v-if="getProfileId === 3">
                        <b-form-group
                            label="Qual é o atual estágio de desenvolvimento da sua iniciativa?"
                            label-for="developmentStage"
                        >
                            <b-form-select
                                id="developmentStage"
                                name="developmentStage"
                                v-model="form.developmentStage.selected"
                                :options="form.developmentStage.options"
                                :disabled="getIsDisabled"
                                v-if="
                                    !isPlatform ||
                                        (isPlatform && getAuthorizationData && getAuthorizationData['id_estagio'].value)
                                "
                            ></b-form-select>

                            <NoAuthorizationMsgPP
                                v-if="isPlatform && getAuthorizationData && !getAuthorizationData['id_estagio'].value"
                            />
                        </b-form-group>

                        <b-form-group label="Atualmente sua iniciativa é:" label-for="currentInitiativeStatus">
                            <b-form-select
                                id="currentInitiativeStatus"
                                name="currentInitiativeStatus"
                                v-model="form.currentInitiativeStatus.selected"
                                :options="form.currentInitiativeStatus.options"
                                :disabled="getIsDisabled"
                                v-if="
                                    !isPlatform ||
                                        (isPlatform &&
                                            getAuthorizationData &&
                                            getAuthorizationData['id_atualmente'].value)
                                "
                            ></b-form-select>

                            <NoAuthorizationMsgPP
                                v-if="
                                    isPlatform && getAuthorizationData && !getAuthorizationData['id_atualmente'].value
                                "
                            />
                        </b-form-group>

                        <b-form-group
                            label="Qual(is) dos modelos de receita está presente no modelo de negócio de sua iniciativa?"
                            label-for="businessModel"
                        >
                            <b-form-checkbox-group
                                id="business-model"
                                name="businessModel"
                                v-model="form.businessModel.selected"
                                :options="form.businessModel.options"
                                value-field="item"
                                text-field="text"
                                :disabled="getIsDisabled"
                                v-if="
                                    !isPlatform ||
                                        (isPlatform &&
                                            getAuthorizationData &&
                                            getAuthorizationData['modelo_receita'].value)
                                "
                            ></b-form-checkbox-group>

                            <NoAuthorizationMsgPP
                                v-if="
                                    isPlatform && getAuthorizationData && !getAuthorizationData['modelo_receita'].value
                                "
                            />
                        </b-form-group>
                    </div>
                </div>
            </div>

            <hr class="line" />

            <div class="footer-buttons">
                <b-button
                    :variant="'secondary'"
                    class="radius-6"
                    @click="$router.push({ name: 'AboutInitiativeForm3' })"
                    v-if="!showFooterButtons"
                    >Voltar</b-button
                >

                <b-button type="submit" :variant="'primary'" class="radius-6 submit" v-if="!showFooterButtons"
                    >Próximo</b-button
                >

                <div class="display-initial" v-if="showFooterButtons">
                    <b-button :variant="'secondary'" @click="changeRegisterForm('AboutInitiativeForm3')"
                        >Voltar</b-button
                    >

                    <b-button :variant="'primary'" @click="changeRegisterForm('AboutInitiativeForm5')">
                        Próximo
                    </b-button>
                </div>

                <b-button
                    variant="success"
                    @click=";(isUpdate = true), onSubmit()"
                    v-if="getEditionMode && !getIsDisabled"
                >
                    Salvar
                </b-button>
            </div>
        </b-form>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import { required } from 'vuelidate/lib/validators'
import { AboutInitiativeApi } from '../../api/about-initiative'
import { AuthorizationApi } from '../../api/admin/authorization-api'
import NoAuthorizationMsgPP from '@/ui/no-authorization-msg-pp/NoAuthorizationMsgPP'

const authorizationApi = new AuthorizationApi()
const aboutInitiativeApi = new AboutInitiativeApi()

export default {
    components: { DangerModalPP, NoAuthorizationMsgPP },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        },
        receiveData: {
            default: null
        },
        showFooterButtons: {
            type: Boolean,
            default: false
        },
        userIdLogged: {
            default: null
        },
        allowAuthorization: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isDisabled: null,
            progress: 27.7,
            initiative: null,
            message: null,
            isUpdate: false,
            authorizationData: null,
            form: {
                isInnovative: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 0 }
                    ]
                },
                isInnovativeMotive: null,
                maturityStage: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                },
                financierCategory: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                },
                developmentStage: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                },
                currentInitiativeStatus: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                },
                businessModel: {
                    selected: [],
                    options: [
                        { text: 'B2B (Uma empresa privada)', item: 1, value: 1 },
                        { text: 'B2C (O consumidor final)', item: 2, value: 2 },
                        { text: 'B2G (Governo)', item: 3, value: 3 },
                        {
                            text:
                                'B2B2C (vendas pela internet que inclui toda a cadeia comercial, desde a indústria até o consumidor final)',
                            item: 4,
                            value: 4
                        },
                        { text: 'Ainda não tem clientes', item: 5, value: 5 }
                    ]
                }
            }
        }
    },
    validations: {
        form: {
            isInnovative: {
                selected: { required }
            },
            financierCategory: {
                selected: {
                    required() {
                        return !(this.form.financierCategory.selected === null && this.getProfileId === 1)
                    }
                }
            }
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform', 'setProgress']),
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        fetchRead() {
            const data = this.receiveData
            this.initiative = data

            this.form.isInnovative.selected =
                data.considera_atuacao_iniciativa !== null ? Number(data.considera_atuacao_iniciativa) : null
            this.form.isInnovativeMotive = data.explique
            this.form.maturityStage.selected = data.id_maturidade
            this.form.financierCategory.selected = data.id_categoria_financiadora
            this.form.developmentStage.selected = data.id_estagio
            this.form.currentInitiativeStatus.selected = data.id_atualmente
            this.form.businessModel.selected = data.modelo_receita || []

            this.setIsLoading(true)

            axios
                .all([
                    aboutInitiativeApi.getMaturity(),
                    aboutInitiativeApi.getFinancialCategory(),
                    aboutInitiativeApi.getDevelopmentStage(),
                    aboutInitiativeApi.getCurrentlyInitiative()
                ])
                .then(response => {
                    this.form.maturityStage.options.push(
                        ...response[0].data.map(item => ({ value: item.id, text: item.maturidade }))
                    )

                    this.form.financierCategory.options.push(
                        ...response[1].data.map(item => ({ value: item.id, text: item.categoria_financiadora }))
                    )

                    this.form.developmentStage.options.push(
                        ...response[2].data.map(item => ({ value: item.id, text: item.estagio }))
                    )

                    this.form.currentInitiativeStatus.options.push(
                        ...response[3].data.map(item => ({ value: item.id, text: item.atualmente }))
                    )

                    this.fetchAuthorization()
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.filterData()
                    this.setIsLoading(false)
                })
        },
        fetch() {
            this.setIsLoading(true)

            axios
                .all([
                    aboutInitiativeApi.getAboutInitiative(),
                    aboutInitiativeApi.getMaturity(),
                    aboutInitiativeApi.getFinancialCategory(),
                    aboutInitiativeApi.getDevelopmentStage(),
                    aboutInitiativeApi.getCurrentlyInitiative()
                ])
                .then(response => {
                    const data = response[0].data.data
                    if (data !== null) {
                        this.initiative = data
                        this.form.isInnovative.selected =
                            data.considera_atuacao_iniciativa !== null
                                ? Number(data.considera_atuacao_iniciativa)
                                : null
                        this.form.isInnovativeMotive = data.explique
                        this.form.maturityStage.selected = data.id_maturidade
                        this.form.financierCategory.selected = data.id_categoria_financiadora
                        this.form.developmentStage.selected = data.id_estagio
                        this.form.currentInitiativeStatus.selected = data.id_atualmente
                        this.form.businessModel.selected = data.modelo_receita || []
                    }

                    this.form.maturityStage.options.push(
                        ...response[1].data.map(item => ({ value: item.id, text: item.maturidade }))
                    )

                    this.form.financierCategory.options.push(
                        ...response[2].data.map(item => ({ value: item.id, text: item.categoria_financiadora }))
                    )

                    this.form.developmentStage.options.push(
                        ...response[3].data.map(item => ({ value: item.id, text: item.estagio }))
                    )

                    this.form.currentInitiativeStatus.options.push(
                        ...response[4].data.map(item => ({ value: item.id, text: item.atualmente }))
                    )
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        onSubmit(event) {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            const currentProgress = this.getProgress < this.progress ? this.progress : this.getProgress
            const data = {
                ...this.initiative,
                considera_atuacao_iniciativa: this.form.isInnovative.selected,
                explique: this.form.isInnovativeMotive,
                id_maturidade: this.form.maturityStage.selected,
                id_categoria_financiadora: this.form.financierCategory.selected,
                id_estagio: this.form.developmentStage.selected,
                id_atualmente: this.form.currentInitiativeStatus.selected,
                modelo_receita: this.form.businessModel.selected,
                percentual: currentProgress
            }

            this.setIsLoading(true)
            const request = this.isUpdate
                ? aboutInitiativeApi.updateAboutInitiative(data)
                : aboutInitiativeApi.nextAboutInitiative(data)

            request
                .then(response => {
                    this.setProgress(data.percentual)

                    if (this.isUpdate) {
                        this.changeStatusDisabled(true)
                    } else {
                        this.$router.push({ name: 'AboutInitiativeForm5' })
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        changeStatusDisabled(status) {
            this.isDisabled = status
        },
        onChangeIsInnovative() {
            if (this.form.isInnovative.selected) {
                this.form.financierCategory.selected = null
                this.form.developmentStage.selected = null
                this.form.currentInitiativeStatus.selected = null
                this.form.businessModel.selected = []
            } else {
                this.form.isInnovativeMotive = null
            }
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
            this.scrollBehavior()
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('top-register-painel')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        fetchAuthorization() {
            if (this.allowAuthorization) {
                this.setIsLoading(true)

                authorizationApi
                    .getAboutInitiative(this.userIdLogged)
                    .then(response => {
                        if (response.data.data === null || response.data.data.length === 0) {
                            this.authorizationData = null
                        } else {
                            this.authorizationData = response.data.data
                        }
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        },
        filterData() {
            if (this.receiveData) {
                this.form.businessModel.options = this.form.businessModel.options.filter(x =>
                    this.form.businessModel.selected.includes(x.value)
                )
                this.form.isInnovative.options = this.form.isInnovative.options.filter(
                    x => Number(this.form.isInnovative.selected) === x.value
                )
            }
        }
    },
    computed: {
        getEditionMode() {
            return this.editionMode
        },
        getIsDisabled() {
            return this.isDisabled
        },
        getProgress() {
            return this.$store.state.progress
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getProfileId() {
            return this.$store.state.profileId
        },
        getAuthorizationData() {
            return this.authorizationData
        }
    },
    created() {
        this.isDisabled = this.disabled
        this.receiveData === null ? this.fetch() : this.fetchRead()
    }
}
</script>

<style scope src="./AboutInitiativeForm4-light-theme.css"></style>



// WEBPACK FOOTER //
// src/components/register-about-initiative-forms/AboutInitiativeForm4.vue